import * as React from "react";
import { connect } from "react-redux";
import RxNumber from "../common/RxNumber";
import DatePicker from "../common/DatePicker";
import * as types from "../../constants/actionTypes";
import SectionLoading from '../common/SectionLoading';
import { Link, withRouter } from "react-router-dom";
import { logUI } from "../../api/andyliticsApi";
import * as Tools from "../../helpers/Tools";
import * as msgs from "../../constants/textConstants";
import ConfirmationModal from '../common/ConfirmationModal';
import Spinner from "../common/spinner";
import SuccessBanner from './SuccessBanner';


class LinkPharmacy extends React.Component {
    constructor(props) {
        super(props);
        this.rxNumberId = 'rxNumber';
        this.dobId = 'dob';
        this.state = {
            gotFocus: false, editing: props.openPharmacy ? true : false, showMessage: false,
            rxNumber: '', isRxNumberValid: false, rxNumberTouched: false,
            dob: '', isValid: false, isDobValid: false, dobTouched: false
        };
        this.props.unlinkedRxTransfer();
        this.isMobileQueryValue = Tools.isMobileQuery(props.location);
        this.rxLinkingCallback = this.rxLinkingCallback.bind(this);
        this.isFromMobile = false;
    }

    componentDidMount() {
        this.isFromMobile = this.isMobileQueryValue || Tools.getItemFromSessionStorage('isMobile') || this.props.MobileOnQueryString;
        logUI("MBHWeb.UI.LinkedAccounts.ComponentDidMount", new Date(), Tools.getURLPath());
    }


    componentDidUpdate() {
        if (!this.state.gotFocus) {
            this.setFocus(this.rxNumberId);
        }
    }

    setFocus(inputId) {
        const input = document.getElementById(inputId);
        if (input) {
            input.focus();
        }
        this.setState({ gotFocus: true });
    }

    edit() {
        this.setState({ editing: true, gotFocus: false }, () => Tools.setFocus('rxNumber'));
    }

    cancel() {
        this.setState({ editing: false, rxNumber: '', dob: '', rxNumberTouched: false, dobTouched: false, showMessage: false });
    }

    onRxNumberChange(e, isRxNumberValid) {
        const isValid = isRxNumberValid && this.state.isDobValid;
        this.setState({ rxNumber: e.target.value, isValid, isRxNumberValid, showMessage: false, rxNumberTouched: true });
    }

    onDobChange(value, isDobValid) {
        const isValid = isDobValid && this.state.isRxNumberValid;
        this.setState({ dob: value, isValid, isDobValid, showMessage: false, dobTouched: true });
    }

    onSetupAccount() {
        const { isValid, rxNumber, dob, isRxNumberValid } = this.state;
        const { link, userDetails } = this.props;

        this.setState({ rxNumberTouched: true, dobTouched: true });
        if (isValid) {
            link(userDetails, rxNumber, dob, this.rxLinkingCallback);
            this.setState({ showMessage: true });
        }
        else {
            if (!isRxNumberValid) {
                this.setFocus(this.rxNumberId);
            }
            else {
                this.setFocus(this.dobId);
            }
        }
    }

    rxLinkingCallback(linkedAccount) {
        if (linkedAccount && this.props.onLinked && this.isFromMobile) {
            this.props.onLinked();
        }
    }

    render() {
        const { rxDown, hasPharmacyLogin, unLinkedRxTransfer, linking, errorMessage, relogin, isProxyUser, MobileOnQueryString, successMessage } = this.props;
        const { editing, rxNumber, dob, showMessage, rxNumberTouched, dobTouched, isValid } = this.state;

        if (isProxyUser) {
            return "";
        }

        return (
            <div className="row">
                <div className="col-12 list-item-col not-linked">
                    <div className="row align-items-end">
                        <div className="col-12 col-sm-6 col-lg-3">
                            <div className="list-item-col__label">{msgs.PharmacyTileName}</div>
                        </div>
                        <div className="col-12 col-sm-6 col-lg-4 text-left text-sm-right text-lg-left">
                            <div className="list-item-col__info">
                                {rxDown ? hasPharmacyLogin ? <div className="list-item-col__info--linked">Account linked <span className="icon-link" /></div> : <div className="unable-display">Unable to display</div>
                                    : hasPharmacyLogin ? <div className="list-item-col__info--linked">Account linked <span className="icon-link" /></div>
                                    : unLinkedRxTransfer
                                        ? <div className="list-item-col__info--pending">Pending</div>
                                            : <div className="list-item-col__info--unlinked">Not linked</div>
                                }
                            </div>
                        </div>
                        <div className="col-12 col-lg-5 text-sm-right">
                            {linking ? <Spinner /> : hasPharmacyLogin ? null :
                                <>{!hasPharmacyLogin && !linking && !relogin && !unLinkedRxTransfer &&
                                    <div className="list-item-col__action">
                                        {!editing
                                            ? rxDown === false && <button type="button" className="list-item-col__action--save btn btn-link-style" onClick={() => this.edit()}>Link account</button>
                                            : null
                                        }
                                    </div>
                                }</>
                            }
                        </div>
                    </div>

                    {!hasPharmacyLogin && !linking && editing && !relogin &&
                        <div className="row edit-mode">
                            <div className="col-12 col-sm-6 form-group">
                                <RxNumber rxNumberId={this.rxNumberId} value={rxNumber} required placeholder="Active RX Number" id="rxNumber"
                                    touched={rxNumberTouched} onChange={(e, isRxNumberValid) => this.onRxNumberChange(e, isRxNumberValid)}
                                    inputErrorMsg="Please enter a minimum of 7 digits." minLength={7}
                                    tooltipID="activeRXToolTip" tooltipMsg="Enter the digits before the dash [xxxxxx]-xx from your most recent, active prescription."
                                />
                            </div>
                            <div className="col-12 col-sm-6 form-group">
                                <DatePicker dobId={this.dobId} value={dob} required type="text" touched={dobTouched} placeholder={"Date of Birth (MM/DD/YYYY)"}
                                    inputErrorMsg={"Please enter a valid date of birth."} yearsBackward={140} maxDate={new Date()}
                                    onChange={(value, isDobValid) => this.onDobChange(value, isDobValid)} disabled
                                />
                        </div>
                        {!successMessage && showMessage &&
                            <div className="col-12">
                                <div className="error-msg" dangerouslySetInnerHTML={errorMessage} />
                            </div>}
                        {editing &&
                            <div className="col-12 col-lg-12 text-sm-right">
                                <div className="list-item-col__action">
                                <button type="button" className="list-item-col__action--btn cancel btn" onClick={() => this.cancel()}>Cancel</button>
                                <button type="button" className="list-item-col__action--btn btn" disabled={!isValid} onClick={() => this.onSetupAccount()}>Verify and Link</button>
                                </div>
                            </div>
                        }
                        
                            {!this.isFromMobile &&
                                <div className="col-12">
                            <div className={`info-banner ${ showMessage ? " msg-above" : ""}`}>
                                Don’t have an active BSW pharmacy RX number? To set up your pharmacy by transferring a prescription <Link to={{ pathname: "/nonbswtransfer" }}>click here</Link>
                                </div>
                                </div>
                            }
                        </div>
                    }
                    <SuccessBanner showMessage={showMessage && successMessage} message={successMessage} />
                </div>
                <ConfirmationModal when={editing && (rxNumber !== '' || dob !== '')} />
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const { isLinking, linkPharmacyError, linkedAccount } = state.pharmacy;
    const hasPharmacyLogin = state.memberships.isActiveFeature_Pharmacy;
    const { technicalHelpDeskNumber, technicalHelpDeskHours } = state.session.serverData;
    let errorMessage = '';
    let successMessage = '';
    let relogin = false;

    if (!isLinking && linkPharmacyError) {
        if (linkPharmacyError.status === 409 && !hasPharmacyLogin) {
            errorMessage = `You may have duplicate accounts. Contact the MyBSWHealth Technical Help Desk ${technicalHelpDeskHours} at ${technicalHelpDeskNumber} to correct this.`
            const matchedPhoneNumber = errorMessage.match(/.*(\d{3}\.\d{3}\.\d{4}).*/) && errorMessage.match(/.*(\d{3}\.\d{3}\.\d{4}).*/)[1];
            const phoneNumber = `<a href="tel:${matchedPhoneNumber}">${matchedPhoneNumber}</a>`;
            if (errorMessage && matchedPhoneNumber)
                errorMessage = errorMessage.replace(matchedPhoneNumber, phoneNumber);
            //errorMessage = 'Your account is already linked. Please log out and sign back in to see your new pharmacy details.';
            //relogin = true;
        }
        else {
            errorMessage = 'Your pharmacy information could not be verified. Try again.'
        }
    }

    if (!isLinking && linkedAccount) {
        successMessage = "We have successfully linked your BSW pharmacy.";
    }

    return {
        userDetails: state.sso.userDetails,
        unLinkedRxTransfer: state.pharmacy.unLinkedRxTransfer,
        rxDown: state.common.rxDown,
        hasPharmacyLogin: hasPharmacyLogin,
        linking: isLinking,
        errorMessage: { __html: errorMessage },
        successMessage: successMessage,
        relogin: relogin,
        isProxyUser: state.domain.ip,
        MobileOnQueryString: state.domain.mq
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        link: (userDetails, rxNumber, dob, callback) => {
            const data = {
                rxNumber: rxNumber,
                DateOfBirth: dob,
                loginId: userDetails.userName,
                FirstName: userDetails.Givenname,
                LastName: userDetails.Surname
            };
            dispatch({ type: types.LINK_PHARMACY, accountToLink: data, callback });
        },
        unlinkedRxTransfer: (proxyId) =>
            dispatch({
                type: types.UNLINK_RX_TRANSFER_START,
                payload: { proxyId: proxyId }
            })
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(LinkPharmacy);